module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG56e86d642286fcd631d21b2fd4692a6f.56e86d64.png";